export default __webpack_public_path__ + "static/hw_ff_ultra-led_schem-96361fab775f82e42b3f7618cecbfed7.png";